import { useState } from 'react'

import { PktBackLink, PktButton } from '..'

const eksotiskeDyr = [
  'Okapi',
  'Numbat',
  'Aye-aye',
  'Axolotl',
  'Quokka',
  'Narhval',
  'Manul',
  'Tarsier',
  'Fossa',
  'Dugong',
]

export default function BackLink() {
  const [dyr, setDyr] = useState('Enhjørninger')

  const handleClick = () => {
    const tilfeldigDyr = eksotiskeDyr[Math.floor(Math.random() * eksotiskeDyr.length)]
    setDyr(tilfeldigDyr)
  }

  return (
    <main className="page-main pkt-container pkt-container--laptop">
      <h1>BackLink</h1>
      <section className="component">
        <div className="component__example" style={{ marginTop: '1rem' }}>
          <PktBackLink href="/" text="Fabeldyr" />
        </div>
        <div className="component__example" style={{ marginTop: '1rem' }}>
          <PktBackLink href="/" text="Engler" />
        </div>
        <div className="component__example" style={{ marginTop: '1rem' }}>
          <PktBackLink ariaLabel="egen arialabel for Navigasjonen" href="/" text="Nisser" />
        </div>
        <div className="component__example" style={{ marginTop: '1rem' }}>
          <PktBackLink text={dyr} href={`/${dyr.toLowerCase()}`} />
        </div>

        <PktButton size="small" color="green" onClick={handleClick} style={{ marginTop: '1rem' }}>
          Bytt til et eksotisk dyr!
        </PktButton>
      </section>
    </main>
  )
}
